import { PureComponent } from 'react';
import { flow, omit, uniq, keys } from 'lodash/fp';
import getDisplayName from './getDisplayName';

const getPropTypesArray = (Component) => {
  const { WrappedComponent } = Component;

  let array = keys(Component.propTypes);

  if (WrappedComponent) {
    array = [...getPropTypesArray(WrappedComponent), ...array];
  }

  return array;
};

const createGetter = flow(getPropTypesArray, uniq, omit);

export default (restKey = 'rest') =>
  (WrappedComponent) => {
    const displayName = getDisplayName(WrappedComponent);
    const getRestProps = createGetter(WrappedComponent);

    return class RestPropsProvider extends PureComponent {
      static displayName = `RestPropsProvider(${displayName})`;
      static WrappedComponent = WrappedComponent;

      getProps() {
        return {
          ...this.props,
          [restKey]: getRestProps(this.props),
        };
      }

      render() {
        return <WrappedComponent {...this.getProps()} />;
      }
    };
  };
